import authHttp, { API_ROOT } from "../services/auth-http";

export const TeamService = {
  getListMember() {
    return authHttp.get(`${API_ROOT}/public/teams`);
  },
};

export default TeamService;
